// extracted by mini-css-extract-plugin
export default {"root":"nvvXQX","icon":"R9loNg","text":"x6eQkg","date":"YHb7Ob","button":"yZvPG0"};